import { AuthContext } from '@lqa-frontend/api-services';
import { useContext } from 'react';

export default () => useContext(AuthContext);
